/**
 * Navigation service for handling redirects from non-React contexts
 */
class NavigationService {
    private navigate: ((path: string) => void) | null = null;

    setNavigate(navigateFunction: (path: string) => void) {
        this.navigate = navigateFunction;
    }

    navigateTo(path: string) {
        if (this.navigate) {
            this.navigate(path);
        } else {
            console.warn('Navigation function not registered. Falling back to window.location');
            window.location.href = path;
        }
    }

    clear() {
        this.navigate = null;
    }
}

export default new NavigationService();
